/* Speed fix 2026-09-19: lazy autoplay for <video data-cc-lazy-video> (snippets/cc-lazy-video.liquid).
   Nothing is downloaded until a video is about to scroll into view; then its poster and source are set
   and it plays muted and inline. It pauses when it leaves the viewport and resumes when it is back. */
(function () {
  if (window.ccLazyVideo) {
    window.ccLazyVideo.scan();
    return;
  }
  var observer = null;

  function start(video) {
    if (!video.__ccLoaded) {
      video.__ccLoaded = true;
      var poster = video.getAttribute('data-poster');
      if (poster) video.setAttribute('poster', poster);
      var sources = video.querySelectorAll('source[data-src]');
      for (var i = 0; i < sources.length; i++) {
        sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
        sources[i].removeAttribute('data-src');
      }
      video.load();
    }
    video.muted = true;
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
  }

  function scan() {
    var videos = document.querySelectorAll('video[data-cc-lazy-video]');
    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      if (video.__ccSeen) continue;
      video.__ccSeen = true;
      if (observer) observer.observe(video);
      else start(video);
    }
  }

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) start(video);
          else if (video.__ccLoaded && !video.paused) video.pause();
        });
      },
      { rootMargin: '100px 0px' }
    );
  }

  window.ccLazyVideo = { scan: scan };
  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
})();
